import { AxiosResponse } from 'axios';
import { UDNICK } from '../../../service/udnick';
import { Filter } from 'store/ducks/tracking/types';

const listaDepositantesTracking = {
  listaDepositantesTracking: (inscricao: number[]): Promise<AxiosResponse> =>
    UDNICK.callService('listaDepositantesTracking', { inscricao }),
};

export const TrackingList = {
  getAllData: (
    cd: number | undefined,
    filtro: Filter | undefined,
    inscricao: number[] | undefined,
    tamanhoPagina: number | undefined
  ): Promise<AxiosResponse> =>
    UDNICK.callService('tracking', { cd, filtro, inscricao }, { tamanhoPagina }),
};

export default listaDepositantesTracking;
